import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@/components/modal/index';
import Button from '@/components/button';
import styles from './auido-guide-modal.module.scss';

const AudioGuideModal = (props) => (
  <Modal title="打开麦克风" visible={props.visible} onClose={props.onClose}>
    <div className={styles.content}>
      <div className={styles.info}>在网页地址栏前，开启麦克风</div>
      <img className={styles.image} src="https://m.xiguacity.cn/static/xgim-guide-mic.png" alt="guide" />
      <Button size="l" theme="primary" onClick={props.onClose}>好的</Button>
    </div>
  </Modal>
);

AudioGuideModal.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
};

export default AudioGuideModal;
